import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const FullLoader = () => (
  <div className="grid min-h-screen place-items-center" data-testid="full-page-loader">
    <Loader2 className="h-6 w-6 animate-spin text-emerald-400" />
  </div>
);

export function RequireAuth({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/shop"} replace />;
  return children;
}
